__turbopack_context__.v({
  "heroLinks": "hero-module-scss-module__oZWpLq__heroLinks",
});
